import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "top-box"
};
var _hoisted_2 = {
  class: "back-img"
};
var _hoisted_3 = {
  class: "contain-box"
};
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = {
  class: "tips"
};
var _hoisted_6 = {
  style: {
    "margin-right": "20px"
  }
};
var _hoisted_7 = ["innerHTML"];
import { getNewsDetail } from '@/api/activityNews';
import { useRoute } from 'vue-router';
import { ref } from 'vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var route = useRoute();
    var dataObj = ref({});
    var id = route.query.id;
    var loadArticleDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getNewsDetail(id);
            case 1:
              res = _context.v;
              if (res.data.code === 0) dataObj.value = res.data.data;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function loadArticleDetail() {
        return _ref.apply(this, arguments);
      };
    }();
    loadArticleDetail();
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "back-box"
      }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(dataObj.value.title), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(dataObj.value.createTime), 1), _createElementVNode("span", null, _toDisplayString(dataObj.value.creatorName), 1)]), _createElementVNode("div", {
        innerHTML: dataObj.value.content,
        class: "content-box"
      }, null, 8, _hoisted_7)])])]);
    };
  }
};